/* Court Vibes, 09.09.2026
   Newsletter-Bestaetigungsseite /account/subscribe.

   Warum es diese Datei gibt:
   Wer sich ueber das Newsletter-Feld im Footer anmeldet, laeuft ueber Shopify,
   nicht ueber Klaviyo. Shopify rendert die Bestaetigungsseite selbst unter
   /account/subscribe. Sie hat KEIN Theme-Template, nur den Container
   .shopify-email-marketing-confirmation__container mit h1, zwei Absaetzen und
   einem Abmelden-Link. Ueberschrift und Text kommen aus Shopify und lassen sich
   im Theme-Editor nirgends aendern, ein Knopf zum Shop fehlt ganz.

   Das Aussehen macht assets/cv-newsletter-seite.css. Diese Datei liefert nur
   das, was CSS nicht kann: Ueberschrift und ersten Absatz austauschen und einen
   echten Link auf die Designs einsetzen. Sie laeuft NUR auf dieser einen Seite.

   Warum der Gutschein im Text erwaehnt werden darf, am 09.09.2026 geprueft:
   Der Klaviyo-Flow "Welcome Series (Email)" ist live und wird ausgeloest, sobald
   jemand zur E-Mail-Liste hinzugefuegt wird. Shopify-Anmeldungen landen ueber
   die Klaviyo-Shopify-Synchronisierung genau in dieser Liste, der Rabattcode
   geht also auch ueber diesen Weg raus. Faellt der Welcome-Flow weg, muss der
   Satz hier ebenfalls weg, sonst steht dort ein Versprechen ohne Deckung.

   Wird die Datei entfernt, steht dort wieder Court Vibes als Ueberschrift und
   kein Knopf, die Seite bleibt aber gestaltet. */
(function () {
  if (location.pathname.indexOf('/account/subscribe') !== 0) return;

  var TITEL = 'Du bist angemeldet';
  var TEXT = 'Danke, dass du deine E-Mail-Adresse bestätigt hast. Deinen Gutscheincode über 10 Prozent schicken wir dir gleich per Mail.';

  function bauen() {
    var box = document.querySelector('.shopify-email-marketing-confirmation__container');
    if (!box) return false;
    if (box.getAttribute('data-cv') === 'fertig') return true;

    var h1 = box.querySelector('h1');
    if (h1) h1.textContent = TITEL;

    var p = box.querySelector('p');
    if (p) p.textContent = TEXT;

    if (!box.querySelector('.cv-sub-btn')) {
      var link = document.createElement('a');
      link.className = 'cv-sub-btn';
      link.href = '/collections/designs';
      link.textContent = 'Jetzt Motive entdecken';
      // Vor den Abmelden-Link, damit der Hauptweg oben steht.
      var abmelden = box.querySelector('a:not(.cv-sub-btn)');
      if (abmelden) {
        abmelden.classList.add('cv-sub-abmelden');
        abmelden.parentNode.insertBefore(link, abmelden);
      } else {
        box.appendChild(link);
      }
    }

    box.setAttribute('data-cv', 'fertig');
    return true;
  }

  function start() {
    if (bauen()) return;
    // Falls Shopify den Container erst nachreicht: kurz beobachten, dann aufhoeren.
    var beobachter = new MutationObserver(function () {
      if (bauen()) beobachter.disconnect();
    });
    beobachter.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { beobachter.disconnect(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
